/**
 * Konstanty pro scenu - zkopirovano z API
 * Vyuziva se pro zjisteni dostupnosti ophota.
 * @type {Object}
 */

/**
 * UTM33 polygon CR vcetne bboxu
 *
 * @type {Object}
 */
const statesArea = {
	cs: {
		bbox: [12.17294, 48.50164, 19.00189, 51.00599],
		polygon: [
			[12.06991, 50.26369],
			[12.08715, 50.33584],
			[12.18856, 50.33998],
			[12.30167, 50.24045],
			[12.49678, 50.41215],
			[12.6971, 50.42754],
			[12.81115, 50.47657],
			[12.95943, 50.43222],
			[13.01379, 50.52372],
			[13.17102, 50.52402],
			[13.23109, 50.60678],
			[13.29328, 50.60816],
			[13.35924, 50.66651],
			[13.45583, 50.6266],
			[13.51287, 50.72107],
			[13.83326, 50.74468],
			[13.88978, 50.80989],
			[14.35688, 50.9181],
			[14.23089, 50.98318],
			[14.29391, 51.07243],
			[14.41286, 51.03839],
			[14.52581, 51.05752],
			[14.62508, 50.99363],
			[14.61208, 50.94325],
			[14.67743, 50.93729],
			[14.65316, 50.8684],
			[14.77451, 50.83953],
			[14.81678, 50.88915],
			[14.96822, 50.88474],
			[14.96834, 51.02547],
			[15.17613, 51.03812],
			[15.29677, 50.99028],
			[15.30485, 50.89857],
			[15.40389, 50.81811],
			[15.71238, 50.75646],
			[15.82728, 50.77195],
			[15.88681, 50.69423],
			[15.99725, 50.70226],
			[16.04014, 50.64437],
			[16.09717, 50.68088],
			[16.19385, 50.65542],
			[16.22906, 50.68908],
			[16.36404, 50.67361],
			[16.4723, 50.57521],
			[16.38034, 50.48872],
			[16.2506, 50.43039],
			[16.29032, 50.39848],
			[16.38311, 50.39037],
			[16.40524, 50.34218],
			[16.57228, 50.23909],
			[16.65002, 50.12962],
			[16.69913, 50.11584],
			[16.79322, 50.20394],
			[16.9899, 50.27387],
			[16.83489, 50.40257],
			[16.89005, 50.46497],
			[17.21428, 50.40286],
			[17.26769, 50.34622],
			[17.36083, 50.34455],
			[17.37965, 50.30067],
			[17.44499, 50.2861],
			[17.6179, 50.28794],
			[17.67098, 50.34332],
			[17.72053, 50.34018],
			[17.77843, 50.30611],
			[17.78586, 50.20217],
			[17.63569, 50.15235],
			[17.73743, 50.11898],
			[17.87575, 49.99619],
			[18.03692, 50.08407],
			[18.1296, 50.01601],
			[18.22064, 50.01336],
			[18.30814, 49.95683],
			[18.43661, 49.95574],
			[18.51222, 49.92101],
			[18.58977, 49.93589],
			[18.65532, 49.73044],
			[18.83092, 49.68607],
			[18.87875, 49.51566],
			[18.75895, 49.47112],
			[18.56781, 49.48712],
			[18.39835, 49.3177],
			[18.2123, 49.27392],
			[18.11878, 49.04967],
			[18.0365, 49.00519],
			[17.94261, 49.00533],
			[17.90332, 48.91415],
			[17.80573, 48.90734],
			[17.71933, 48.84533],
			[17.52648, 48.79168],
			[17.46296, 48.82511],
			[17.3531, 48.79675],
			[17.20481, 48.85502],
			[17.06818, 48.75345],
			[16.95041, 48.60016],
			[16.89334, 48.61684],
			[16.88321, 48.69689],
			[16.67121, 48.71161],
			[16.64183, 48.76541],
			[16.47276, 48.7845],
			[16.36748, 48.71021],
			[16.08795, 48.72896],
			[15.81575, 48.85452],
			[15.67985, 48.83897],
			[15.34659, 48.96572],
			[15.15328, 48.92412],
			[15.12396, 48.9793],
			[15.02627, 48.99591],
			[15.00483, 48.76616],
			[14.95605, 48.74013],
			[14.83896, 48.76125],
			[14.7533, 48.68073],
			[14.72567, 48.57254],
			[14.65866, 48.56407],
			[14.59871, 48.60019],
			[14.47503, 48.60977],
			[14.32769, 48.5344],
			[14.04858, 48.58136],
			[13.98496, 48.6334],
			[13.98349, 48.69219],
			[13.79522, 48.7606],
			[13.72282, 48.86017],
			[13.65462, 48.86525],
			[13.56343, 48.94885],
			[13.49531, 48.92351],
			[13.40746, 48.95909],
			[13.32047, 49.07725],
			[13.16422, 49.12105],
			[12.95469, 49.31902],
			[12.77344, 49.32949],
			[12.73259, 49.38563],
			[12.63504, 49.42271],
			[12.4969, 49.66763],
			[12.42417, 49.69024],
			[12.37314, 49.75187],
			[12.52219, 49.90859],
			[12.45543, 49.92548],
			[12.45326, 49.97115],
			[12.2417, 50.04574],
			[12.17317, 50.10439],
			[12.17599, 50.1778],
			[12.06991, 50.26369],
		],
	},
};

/**
 * UTM33 polygon, kde jsou dostupne letecke snimky
 *
 * @type {Array}
 */
const ophotoExtents = [
	statesArea.cs.polygon,
];

export default {
	statesArea,
	ophotoExtents,
};
